export interface ProfileCompletionModel {
  profile_completeness: number;
  general_info: boolean;
  knowledge: boolean;
  soft_skills: boolean;
  language_skills: boolean;
  professions: boolean;
  education: boolean;
  profile_visibility: boolean;
  work_preference: boolean;
}
